<template>
  <div class="ai-global-switch-container">
    <el-card>
      <div slot="header"><span>AI 助手开关</span></div>
      <el-form label-width="120px" size="small">
        <el-form-item label="AI功能总开关">
          <el-switch v-model="form.enabled" active-value="1" inactive-value="0" active-text="开启" inactive-text="关闭"></el-switch>
          <span style="margin-left:12px;color:#909399;font-size:12px">关闭后，所有小区的小程序中将隐藏AI悬浮头像和AI助手入口</span>
        </el-form-item>
        <el-form-item><el-button type="primary" @click="save">保存</el-button></el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return { form: { enabled: '1' } }
  },
  created() { this.load(); },
  methods: {
    async load() {
      try {
        const res = await request({ url: '/ai.listGlobalSwitch', method: 'get', params: { page: 1, row: 1 } });
        const data = res.data;
        if (data.code === 0 && data.data) {
          const config = Array.isArray(data.data) ? data.data[0] : data.data;
          if (config) {
            this.form.enabled = config.enabled || '1';
          }
        }
      } catch(e) { /* no config yet */ }
    },
    async save() {
      try {
        await request({ url: '/ai.saveGlobalSwitch', method: 'post', data: { enabled: this.form.enabled } });
        this.$message.success('保存成功');
      } catch(e) { this.$message.error('保存失败'); }
    }
  }
}
</script>
<style scoped>
.ai-global-switch-container { padding: 20px; }
</style>
